import * as actions from './actions';
import * as constants from './constants';
import * as utils from './utils';
import reducer from './reducer';

export default {
    actions,
    constants,
    reducer,
    utils
};



// WEBPACK FOOTER //
// ./src/services/i18n/index.js